import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Notification} from '../models/notification.model';
import {skip} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NotificationState {

  private notifications$ = new BehaviorSubject<Notification[]>(null);
  private unSeenCount$ = new BehaviorSubject<number>(null);


  updateNotifications(notifications: Notification[]): void {
    this.notifications$.next(notifications);
  }

  filterNotifications(notificationId: string): void {
    let filteredNotifications = this.notifications$.getValue();
    filteredNotifications = filteredNotifications.filter(notify => notify.notificationId !== notificationId);
    this.updateNotifications(filteredNotifications);
  }

  updateSeenNotifications(): void {
    const updateSeenNotifications = this.notifications$.getValue();
    updateSeenNotifications.forEach(notify => notify.seen = true);
  }

  getNotifications$(): Observable<Notification[]> {
    return this.notifications$.asObservable().pipe(skip(1));
  }

  updateUnSeenCount(count: number): void {
    this.unSeenCount$.next(count);
  }

  getUnSeenCount$(): Observable<number> {
    return this.unSeenCount$.asObservable().pipe(skip(1));
  }
}
